<app-header *ngIf="!hideHeaderAndFooter"></app-header>
<main [ngClass]="{ 'main-kiosko': hideHeaderAndFooter }">
    <router-outlet></router-outlet>
</main>
<app-footer *ngIf="!hideHeaderAndFooter"></app-footer>
